module.exports = __webpack_public_path__ + "media/images/icons/outlined/info-circle-90d30ed13ebaf84ba0e33b78f25e20de.svg";